import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const paymentMethodSelector = (state: RootState) =>
  state.amwell.activeConsumer.paymentMethod;

export const paymentMethodDataSelector = createSelector(paymentMethodSelector, p => p.data);
export const paymentMethodDataErrorSelector = createSelector(
  paymentMethodSelector,
  p => p.errors.data
);
export const paymentMethodDataLoadingSelector = createSelector(
  paymentMethodSelector,
  p => p.loading.data
);
export const paymentMethodWasUpdatedSelector = createSelector(
  paymentMethodSelector,
  p => p.paymentMethodWasUpdated
);

export const paymentMethodActionLoadingSelector = createSelector(
  paymentMethodSelector,
  p => p.loading.action
);
export const paymentMethodActionErrorSelector = createSelector(
  paymentMethodSelector,
  p => p.errors.action
);
